import React, { useMemo, useState } from 'react';
import { Button, Card, CardBody, Col, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { ReactComponent as ErrorPageIcon } from '../../../../assets/utils/images/svgs/ErrorPage.svg';
import { useApi } from 'hooks/SwrCustom';
import AfasBatchPayloadModal from '../components/AfasBatchPayloadModal';
import AfasFooterActions from '../components/AfasFooterActions';
import AfasGrid from '../components/AfasGrid';
import AfasListToolbar from '../components/AfasListToolbar';
import { useAfasContext } from '../context/AfasContext';
import { useAfasDebugMode } from '../hooks/useAfasDebugMode';
import { AFAS_SYNCHRONISATIE_COLUMNS } from '../constants';
import Loader from "react-loaders";

const statusClass = (status) => {
    if (status === 'Fout') return 'afas-status afas-status--error';
    if (status === 'Verzonden' || status === 'Verwerkt') return 'afas-status afas-status--success';
    return 'afas-status afas-status--pending';
};

const AfasSynchronisatiePage = () => {
    const { communityId } = useAfasContext();
    const [debugMode] = useAfasDebugMode(communityId);
    const [payloadRow, setPayloadRow] = useState(null);
    const [foutmeldingRow, setFoutmeldingRow] = useState(null);

    const swrKey = communityId ? `afas/synchronisatie?community_id=${communityId}` : null;
    const { data: response, isLoading } = useApi(swrKey);
    const rows = response?.data?.items ?? [];
   const  totalCount=response?.totalCount || 0;


    const columns = useMemo(() => {
        const base = AFAS_SYNCHRONISATIE_COLUMNS.map((column) => {
            if (column.key === 'status') {
                return {
                    ...column,
                    render: (row) => (
                        <span className={statusClass(row.status)}>{row.status}</span>
                    ),
                };
            }
            if (column.key === 'foutmelding') {
                return {
                    ...column,
                    render: (row) =>
                        row.foutmelding ? (
                            <Button
                                type="button"
                                color="link"
                                className="afas-foutmelding-btn"
                                title={row.foutmelding}
                                aria-label={row.foutmelding}
                                onClick={() => setFoutmeldingRow(row)}
                            >
                                <ErrorPageIcon />
                            </Button>
                        ) : (
                            '—'
                        ),
                };
            }
            return column;
        });

        if (!debugMode) {
            return base;
        }

        return [
            ...base,
            {
                key: 'afasPayload',
                label: 'Debug',
                width: '88px',
                render: (row) => (
                    <Button
                        type="button"
                        color="link"
                        className="p-0"
                        onClick={() => setPayloadRow(row)}
                    >
                        Bekijken
                    </Button>
                ),
            },
        ];
    }, [debugMode]);

    return (
        <Row>
            <Col md="12" lg="12">
                <Card className="main-card mb-3">
                    <CardBody className="p-3 table-responsive">
                        <div className="afas-list-page afas-list-page--toolbar-in-footer">
                            <AfasGrid
                                className="afas-grid--synchronisatie shadow-none"
                                columns={columns}
                                rows={rows}
                                totalCount={totalCount}
                                emptyMessage={
                                    isLoading
                                        ? <Loader
                                            type="ball-grid-pulse"
                                            className="mt-3 d-flex mx-auto justify-content-center"
                                        />
                                        : !communityId
                                            ? 'Selecteer een organisatie'
                                            : 'Geen synchronisatie-items gevonden'
                                }
                            />

                            <AfasBatchPayloadModal
                                isOpen={Boolean(payloadRow)}
                                row={payloadRow}
                                onClose={() => setPayloadRow(null)}
                            />

                            <Modal
                                isOpen={Boolean(foutmeldingRow)}
                                toggle={() => setFoutmeldingRow(null)}
                                centered
                            >
                                <ModalHeader toggle={() => setFoutmeldingRow(null)}>
                                    Foutmelding
                                    {foutmeldingRow?.id ? ` — batch ${foutmeldingRow.id}` : ''}
                                </ModalHeader>
                                <ModalBody>
                                    {foutmeldingRow?.foutmelding}
                                </ModalBody>
                                <ModalFooter>
                                    <Button type="button" color="link" onClick={() => setFoutmeldingRow(null)} className="btn-color-style">
                                       sluiten
                                    </Button>
                                </ModalFooter>
                            </Modal>

                            <AfasFooterActions showActions={false}>
                                <AfasListToolbar compact />
                            </AfasFooterActions>
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Row >
    );
};

export default AfasSynchronisatiePage;
